import React, { Component, ReactNode } from 'react';
import { forEach } from 'lodash';
import cIf from 'classnames';

export type DescriptionListItem = {
    defineTerm: ReactNode, 
    description: string
};

export type DescriptionListProps = {
    horizontal?: boolean,
    alignLeft?: boolean,
    children: DescriptionListItem[]
}

export class DescriptionList extends Component<DescriptionListProps> {
    static readonly defaultProps = {
        horizontal: true,
        alignLeft: true
    };

    render() {
        let items = [];

        forEach((this.props.children as DescriptionListItem[]), (child, i) => {
            if(child.description) {
                if(child.defineTerm)
                    items.push(<dt key={`dt_${i}`} className={cIf({ "text-left": this.props.alignLeft })}>{child.defineTerm}</dt>);
                items.push(<dd key={`dd_${i}`}>{child.description}</dd>);
            }
        });
        
        return (
            <dl className={cIf({ "descriptionlist-horizontal": this.props.horizontal })}>
                {items}
            </dl>
        );
    }
}


